"use client";

import { useMemo, useState } from "react";

type Strategy = {
  strategy: string;
  fallback: boolean;
  weights: Record<string, number>;
};

const names: Record<string, string> = {
  manual: "当前人工权重",
  equal_weight: "全因子等权",
  IC_weight: "IC 稳定性权重",
  ICIR_weight: "ICIR 风险调整权重",
};

export default function StrategySelector({
  strategies,
  productionStrategy,
  labels,
}: {
  strategies: Strategy[];
  productionStrategy: string;
  labels: Record<string, string>;
}) {
  const [selected, setSelected] = useState(productionStrategy);
  const strategy = useMemo(
    () => strategies.find((item) => item.strategy === selected) ?? strategies[0],
    [selected, strategies],
  );
  if (!strategy) return null;

  return <div className="strategy-selector">
    <div className="strategy-tabs" role="tablist" aria-label="选择研究算法">
      {strategies.map((item) => <button
        key={item.strategy}
        type="button"
        className={item.strategy === strategy.strategy ? "active" : ""}
        onClick={() => setSelected(item.strategy)}
      >
        <b>{names[item.strategy] ?? item.strategy}</b>
        <small>{item.strategy === productionStrategy ? "当前生产" : item.fallback ? "样本不足，等权回退" : "研究预览"}</small>
      </button>)}
    </div>
    <article className="strategy-preview">
      <header>
        <div><small>SELECTED ALGORITHM</small><h3>{names[strategy.strategy] ?? strategy.strategy}</h3></div>
        <span>{strategy.strategy === productionStrategy ? "生产中" : "只预览，不自动上线"}</span>
      </header>
      <div>{Object.entries(strategy.weights).map(([factor, weight]) => <p key={factor}>
        <span>{labels[factor] ?? factor}</span>
        <i><em style={{ width: `${weight * 100}%` }} /></i>
        <strong>{(weight * 100).toFixed(1)}%</strong>
      </p>)}</div>
    </article>
  </div>;
}
